import React from "react";
import {
  BookOpen,
  Library,
  Globe,
  GraduationCap,
  ArrowUpRight,
} from "lucide-react";

import "./openAccessBooks.style.scss";

const resources = [
  {
    title: "Open Library",
    icon: Library,
    link: "https://openlibrary.org/",
    description:
      "Open Library is an initiative of the Internet Archive, a 501(c)(3) non-profit, building a digital library of Internet sites and other cultural artifacts in digital form.",
  },
  {
    title: "Open Textbook Library",
    icon: GraduationCap,
    link: "https://open.umn.edu/opentextbooks",
    description:
      "Open textbooks are licensed by authors and publishers to be freely used and adapted. Download, edit and distribute them at no cost.",
  },
  {
    title: "Project Gutenberg",
    icon: BookOpen,
    link: "https://www.gutenberg.org/",
    description:
      "Project Gutenberg is a library of over 60,000 free eBooks. Choose among free EPUB and Kindle eBooks, download them or read them online.",
  },
  {
    title: "Directory of Open Access Books (DOAB)",
    icon: Globe,
    link: "https://www.doabooks.org/",
    description:
      "DOAB is a discovery service for peer-reviewed open access books and book publishers that indexes and provides access to high-quality open access books.",
  },
];

const OpenAccessBooks = () => {
  return (
    <div className="open-access-books">
      <div className="container">
        <div className="page-header">
          <span className="badge">Digital Resources</span>
          <h1>Open Access Books</h1>
          <p>
            Access high-quality scholarly and educational books freely
            available online from trusted open-access platforms.
          </p>
        </div>

        <div className="resources-grid">
          {resources.map((resource, index) => {
            const Icon = resource.icon;

            return (
              <a
                key={index}
                href={resource.link}
                target="_blank"
                rel="noopener noreferrer"
                className="resource-card"
              >
                <div className="card-top">
                  <div className="icon-wrapper">
                    <Icon size={28} />
                  </div>

                  <ArrowUpRight size={18} />
                </div>

                <h3>{resource.title}</h3>
                <p>{resource.description}</p>

                <span className="visit-link">
                  Visit Resource
                  <ArrowUpRight size={16} />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OpenAccessBooks;